<template>
  <b-row>
    <b-col>
      <ValidationObserver v-slot="{ handleSubmit }">
        <b-card>
          <template #header>
            <strong>新增帳務資料</strong>
          </template>
          <b-row>
            <b-col sm="2">
              <b-form-group label="類型">
                <b-form-select v-model="data.type" :options="typelist" @change="resetCategory"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="6" md="6">
              <ValidationProvider rules="required" v-slot="v">
                <b-form-group label="分類" :invalid-feedback="v.errors[0]">
                  <b-form-select v-model="data.category" :options="categorylist" :state="v.validated ? v.passed : null"></b-form-select>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col lg="4" md="4">
              <b-form-group label="日期">
                <date-picker v-model="data.date" valueType="format" :clearable="false" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row> </b-row>
          <b-row>
            <b-col sm="8">
              <ValidationProvider rules="required" v-slot="v">
                <b-form-group label="內容" :invalid-feedback="v.errors[0]">
                  <b-form-input v-model="data.content" :state="v.validated ? v.passed : null"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col>
              <ValidationProvider rules="required" v-slot="v">
                <b-form-group label="金額" :invalid-feedback="v.errors[0]">
                  <b-form-input v-model.number="data.price" type="number" :state="v.validated ? v.passed : null"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>
          <template #footer>
            <b-button variant="primary" class="float-right" @click="handleSubmit(onSubmit)"> 確認新增 </b-button>
          </template>
        </b-card>
        <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" no-wrap> </b-overlay>
      </ValidationObserver>
    </b-col>
  </b-row>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/zh-tw";

extend("required", {
  ...required,
  message: "此欄位為必填選項",
});

export default {
  name: "",
  components: {
    DatePicker,
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    loading: false,
    data: {
      date: "",
      category: "",
      type: 0,
      content: "",
      price: 0,
    },
    category: {
      income: [],
      expenditure: [],
    },
    typelist: [
      { text: "收入", value: 0 },
      { text: "支出", value: 1 },
    ],
  }),
  computed: {
    categorylist() {
      return this.data.type === 0 ? this.category.income : this.category.expenditure;
    },
  },
  mounted() {
    this.getCategorylist();
    this.data.date = this.$date().format("YYYY-MM-DD");
  },
  methods: {
    resetCategory() {
      this.data.category = "";
    },
    async getCategorylist() {
      this.category.income = [{ value: "", text: "請選擇分類" }, ...(await this.$function.getCustomItems("AssetRecordIncomeCategory")).map((p) => p.content)];
      this.category.expenditure = [{ value: "", text: "請選擇分類" }, ...(await this.$function.getCustomItems("AssetRecordExpenditureCategory")).map((p) => p.content)];
    },
    onSubmit() {
      this.loading = true;
      this.$http.post("/asset", this.data).then((response) => {
        if (response.data.success) {
          this.$notify({ type: "success", text: "新增成功" });
          //this.$router.push({ name: "收件資料", params: { id: response.data.result.id } });
        } else {
          this.$notify({ type: "error", text: response.data.message });
        }
        this.loading = false;
      });
    },
  },
};
</script>